import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Params } from 'types';

import { Box, Tab, Tabs } from '@mui/material';

import { getIndexById, getSectionByPath, SETTINGS_TABS } from './config';

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function DashboardTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const section = SETTINGS_TABS[newValue].id;
    navigate(section);
  };

  useEffect(() => {
    const index = getIndexById(getSectionByPath(location.pathname));

    if (index > -1) {
      setValue(index);
    }
  }, [location.key]);

  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="Settings navigation"
        indicatorColor="secondary"
        className="uppercase filled strong"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {SETTINGS_TABS.map((item: Params, index: number) => (
          <Tab key={item.id} label={item.name} {...a11yProps(index)} />
        ))}
      </Tabs>
    </Box>
  );
}
